import images from 'assets/images/images'
import Input from 'components/form-elements/Input'
import Button from 'components/form-elements/buttons/Button'
import useGeolocation from 'hooks/useGeolocation'
import { useRequest } from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import { useEffect, useState } from 'react'
import {MapContainer, Marker, TileLayer, useMap, useMapEvents} from 'react-leaflet'
import {useDispatch} from 'react-redux'
import {currentLocationFunc, setPinMapModal} from 'redux/features/general/generalSlice'

const PinMapContent = () => {
const [request] = useRequest()
const [currentLocation, setCurrentLocation] = useState(null)
const {geolocation,setGeolocation, error} = useGeolocation()
const {t} = useTranslate()
  function LocationMarker() {
    const mapp = useMap()
    console.log(mapp,'maappp')
    // eslint-disable-next-line no-unused-vars
    const map = useMapEvents({
        click(e) {
        console.log('location found:', e)
            setGeolocation(e.latlng)
        },
        locationfound: (e) => {
            console.log(e,'eeee')
        },
      })
  
    return geolocation === null ? null : (
      <Marker position={geolocation}>
      </Marker>
    )
  }
    const dispatch = useDispatch()



    useEffect(() => {
      if(geolocation){
        request(`/Location/AddressFromCoordinates?latY=${geolocation[0]}&longX=${geolocation[1]}`, {
          method: 'GET',
        }).then((res) => {
          if (res) {
           setCurrentLocation(res.data.result)
          }
        })
      }   
    },[geolocation])

    const choiceLocationNext = () => {
     
       dispatch(currentLocationFunc(
        {
          province: currentLocation.provinceName,
          provinceId: currentLocation.provinceId,
          district: currentLocation.districtName,
          districtId: currentLocation.districtId,
          neighbourhood:currentLocation.neighbourhoodName,
          neighbourhoodId:currentLocation.neighbourhoodId,
          street: currentLocation.streetName,
          streetId: currentLocation.streetId,
          building: currentLocation.building,
          buildingId: currentLocation.buildingId,
          countryName: currentLocation.countryName,
          latitude: geolocation[0],
          longitude: geolocation[1]
        }
       ))
       dispatch(setPinMapModal({open:false}))
    }


  return (
    <div className={`pinmap-wrapper ${geolocation && 'bg-white'}`}>
        {
            error ? <div className='pinmap-location-error'>
                <img src={images.modalInfo} alt="" />
                <div className="header-l">
                    {t('needLocationPerm')} 
                </div>
                <div className="body-m">
                    {t('youCanAllowLocationPerm')}
                </div>
                <button className='btn-primary-outline' onClick={() => dispatch(setPinMapModal({open:false}))}>{t('cancel')}</button>
            </div>
            :geolocation && <div>
                <MapContainer className='pinmap-map' center={geolocation} zoom={13} scrollWheelZoom={false}>
                    <TileLayer
                        url='https://bms.basarsoft.com.tr/Service/api/v1/map/ProMap?accId=A0oZw2MGHkaQc0lBeYe-Zw&appCode=eUZ2DGOLvkikAbBndtrMJQ&x={x}&y={y}&z={z}'
                    />
                    <LocationMarker/>
                </MapContainer>
                <div className="pinmap-footer">
                <Input type={"text"} label={t('yourCurrentLocation')} value={`${currentLocation?.countryName},${currentLocation?.provinceName},${currentLocation?.districtName},${currentLocation?.streetName}`}/>
                {/* <ReactSelect value={{ value: 'tr', label: `${currentLocation?.countryName},${currentLocation?.provinceName},${currentLocation?.districtName},${currentLocation?.streetName}`}} labelText={"Mevcut konumunuz"} placeholder={"Ülke"} options={adressLocations} defaultValue={adressLocations} /> */}
                <div className="pinmap-footer-buttons">
                    <Button className='btn-primary-outline' text={t('cancel')} />
                    <Button onClick={choiceLocationNext} className='btn-primary' text={t('continueWithSelectedLocation')} />
                </div>
                </div>
            </div>
        }
    </div>
  )
}

export default PinMapContent